import React, { Component } from 'react';
import { Divider, Form, Grid, Label } from 'semantic-ui-react';
import CustomRadioButtonV1 from '../../../../app/common/Form/CustomRadioBtnV1/CustomRadioButtonV1';
import CardIcon from '../CardIcon';
import { isMobile } from 'react-device-detect';

export default class SingleOptionRow extends Component {
  state = { cvv: '', showCVVError: false };

  constructor(props) {
    super(props);

    const { card } = this.props;

    // set card length based on cardBrand
    this.cardLength = card.cardBrand.toLocaleLowerCase() === 'amex' ? 4 : 3;

    this.cvvNumberError = 'Please enter valid CVV';
  }

  componentDidMount() {
    if (this.props.selected) {
      this.handClick();
    }
  }

  handClick = () => {
    // Send card details to parent component when clicked
    this.props.select(this.props.card);

    this.setFocus();
  };

  handleCVV = event => {
    const val = event.target.value;

    if (val !== '' && !/^\d+$/.test(val)) {
      this.setState({ showCVVError: true });
    } else {
      this.setState({ showCVVError: false, cvv: val });

      // Send Card details to parent component, when length reaches the cardLength
      if (val.length === this.cardLength)
        this.props.select({ ...this.props.card, cvv: val });
    }
  };

  setFocus = () => {
    const { card, selectedCard } = this.props;

    const nameInput = this.nameInput;

    // If token from card details and selected token are equal then set focus to cvv field
    if (card.cardToken === selectedCard.cardToken) {
      nameInput.focus();
    }
  }

  handleOnBlur = () => (
    this.setState({
      showCVVError: (this.state.cvv.toString().length !== this.cardLength) ? true : false
    })
  );

  render() {
    const { card, selectedCard } = this.props;

    let cvv = '';

    // Set CVV value if card token is equal to selected card token
    if (card.cardToken === selectedCard.cardToken) {
      cvv = this.state.cvv;
    } else {
      cvv = '';
    }

    // Reduce the number XX in given mask number
    let mask = card.cardMask;
    mask = mask.split(/X/);
    mask = mask[0] + 'XXX' + mask[mask.length -1 ];

    return (
      <React.Fragment>
        <Grid className="clickable" onClick={this.handClick}>
          <Grid.Row>
            <Grid.Column width={1}>
              <CustomRadioButtonV1
                checked={card.cardToken === selectedCard.cardToken}
              />
            </Grid.Column>

            <Grid.Column width={isMobile ? 3 : 2}>
              <CardIcon card={card} />
            </Grid.Column>

            <Grid.Column width={isMobile ? 6 : 11} style={{ fontSize: '12px', color: '#aaa' }}>
              {mask} <br /> {card.cardBrand}
            </Grid.Column>

            <Grid.Column width={isMobile ? 5 : 2}>
              <Form.Field>
                <input
                  type="tel"
                  allowonlynumber="true"
                  disabled={card.cardToken !== selectedCard.cardToken}
                  ref={input => {
                    this.nameInput = input;
                  }}
                  onChange={this.handleCVV}
                  onBlur={this.handleOnBlur}
                  maxLength={this.cardLength}
                  value={cvv}
                  autoComplete="off"
                  placeholder="CVV"
                  className="securityfield"
                  onKeyPress={e => {
                    const key=e.keyCode || e.which;
                    if (key === 13)
                      e.preventDefault();
                  }}
                />
              </Form.Field>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={isMobile ? 4 : 1} />
            <Grid.Column width={isMobile ? 8 : 15}>
              {this.state.showCVVError && (
                <Label className="floatRight" basic color="red">
                  {this.cvvNumberError}
                </Label>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Divider />
      </React.Fragment>
    );
  }
}
